/*
 * Author: Alexandre Havrileck (Oxyno-zeta)
 * Date: 27/02/18
 * Licence: See Readme
 */

/* ************************************* */
/* ********       IMPORTS       ******** */
/* ************************************* */

/* ************************************* */
/* ********      VARIABLES      ******** */
/* ************************************* */
const ERROR = 'Error';
const OBJECT = 'Object';
const ARRAY = 'Array';
const STRING = 'String';
const NUMBER = 'Number';
const BOOLEAN = 'Boolean';
const DATE = 'Date';
const NULL = 'Null';
const UNDEFINED = 'Undefined';
const FUNCTION = 'Function';
const SYMBOL = 'Symbol';

/* ************************************* */
/* ********       CLASSES       ******** */
/* ************************************* */

/* ************************************* */
/* ********  PRIVATE FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********   PUBLIC FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********       EXPORTS       ******** */
/* ************************************* */
export default {
    ERROR,
    OBJECT,
    ARRAY,
    STRING,
    NUMBER,
    BOOLEAN,
    DATE,
    NULL,
    UNDEFINED,
    FUNCTION,
    SYMBOL,
};
